import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = { class: "form-group mb-2" }
const _hoisted_10 = { class: "d-block mt-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = { class: "text-center mt-3" }
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Edit Production Process",
          text: "Edit Production Process"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_localized_text, {
              type: "label",
              localizedKey: "Production Process",
              text: "Production Process"
            }),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.productionProcessName), 1)
          ])
        ])
      ]),
      _hoisted_11,
      _createVNode(_component_form_field, {
        type: "number",
        labelKey: _ctx.localModel.watt.key + ' (watt)',
        labelValue: _ctx.localModel.watt.key + ' (watt)',
        placeholderKey: _ctx.localModel.watt.key + ' (watt)',
        placeholderValue: _ctx.localModel.watt.key + ' (watt)',
        modelValue: _ctx.localModel.watt.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localModel.watt.value) = $event))
      }, null, 8, ["labelKey", "labelValue", "placeholderKey", "placeholderValue", "modelValue"]),
      _createVNode(_component_form_field, {
        type: "number",
        labelKey: _ctx.localModel.minutes.key + ' (min)',
        labelValue: _ctx.localModel.minutes.key + ' (min)',
        placeholderKey: _ctx.localModel.minutes.key + ' (min)',
        placeholderValue: _ctx.localModel.minutes.key + ' (min)',
        modelValue: _ctx.localModel.minutes.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModel.minutes.value) = $event))
      }, null, 8, ["labelKey", "labelValue", "placeholderKey", "placeholderValue", "modelValue"]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: _ctx.disabled,
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Edit",
            text: "Edit"
          })
        ], 8, _hoisted_13)
      ])
    ])
  ]))
}